module.exports = __webpack_public_path__ + "static/media/instagram-original.b5177787.svg";